module.exports = __webpack_public_path__ + "img/4064010600.2b80deac.jpg";